export class Historic {
    id: number;
    name: string;
}
